import { Injectable } from '@angular/core';

import { GridController, TSortDirections } from '../../classes/grid-page-info';
import { FilterItems } from '../../components/filters/filter.interface';
import {
  InsuranceCompanySearchResponseConnection,
  InsuranceFilters,
} from '../../interfaces/insurance/insurance.interface';
import { CommonGraphqlService } from '../common.graphql.service';

@Injectable({
  providedIn: 'root',
})
export class InsuranceStateService extends GridController<InsuranceFilters> {
  private _insurance: InsuranceCompanySearchResponseConnection[];

  private _filter: InsuranceFilters = {
    formatType: '',
    insuranceCode: '',
    name: '',
    recId: undefined,
    recordStatus: '',
    requiresEnrollment: '',
    ediId: '',
    processorId: '',
  };

  insuranceFilters: FilterItems = {
    filtersName: 'Insurance',
    items: [
      {
        name: 'name',
        caption: 'name',
        type: 'text',
        placeholder: 'Enter Name',
      },
      {
        caption: 'Processor Id',
        name: 'processorId',
        type: 'text',
        placeholder: 'Enter Processor ID',
      },
      {
        caption: 'edi ID',
        name: 'ediId',
        type: 'text',
        placeholder: 'Enter EDI ID',
      },
      {
        caption: 'State',
        name: 'state',
        type: 'states',
      },
      {
        name: 'recordStatus',
        type: 'checkbox',
        values: [{ text: 'Show Inactive Only', value: 'I' }],
      },
    ],
  };

  override _sortDirections: TSortDirections = {
    formatType: '',
    insuranceCode: '',
    name: 'ASC',
    recId: '',
    recordStatus: '',
    requiresEnrollment: '',
  };

  constructor(private commonGraphqlService: CommonGraphqlService) {
    super();
    this.init(this._filter, 1, 'name');
  }

  get insurances(): InsuranceCompanySearchResponseConnection[] {
    return this._insurance;
  }

  set insurances(value: InsuranceCompanySearchResponseConnection[]) {
    this._insurance = value;
  }

  // getStates():Observable<DropDownItem[]>{
  //   return this.commonGraphqlService.getStates();
  // }
}
